// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ro-page {
  --bg: #ffffff;
  --surface: #ffffff;
  --surface-2: #f8fafc;
  --ink: #1e293b;
  --ink-2: #475569;
  --ink-3: #94a3b8;
  --line: #e2e8f0;
  --shadow-sm:
    0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.08);
  --shadow-md:
    0 2px 4px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.08);
  --ok-bg: #ecfdf5;
  --ok: #047857;
  --warn-bg: #fffbeb;
  --warn: #b45309;
  --bad-bg: #fef2f2;
  --bad: #b91c1c;
  --accent: #185fa5;
  --accent-bg: #eff6ff;
  --r: 10px;
  --r-sm: 7px;

  min-height: 100vh;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  color: var(--ink);
  background: var(--bg);
}

.ro-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 18px 20px 0;
  flex-wrap: wrap;
}

.ro-title {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ro-subtitle {
  margin: 6px 0 0;
  color: var(--ink-3);
  font-size: 13px;
  max-width: 520px;
}

.ro-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 20px;
}

.ro-kpi {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  padding: 14px 16px;
  box-shadow: var(--shadow-sm);
}

.ro-kpi-label {
  font-size: 11px;
  color: var(--ink-3);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ro-kpi-val {
  font-size: 28px;
  font-weight: 700;
  margin-top: 4px;
}

.ro-kpi-val-sm {
  font-size: 18px;
}

.ro-kpi-foot {
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 2px;
}

.ro-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 14px;
  padding: 0 20px 24px;
  min-height: 480px;
}

@media (max-width: 900px) {
  .ro-layout {
    grid-template-columns: 1fr;
  }
  .ro-kpis {
    grid-template-columns: 1fr;
  }
}

.ro-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.ro-panel-main {
  min-height: 420px;
}

.ro-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
  background: var(--surface-2);
}

.ro-panel-head-split {
  align-items: flex-start;
  gap: 12px;
}

.ro-panel-title {
  font-weight: 600;
  font-size: 14px;
}

.ro-panel-sub {
  display: block;
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 2px;
}

.ro-panel-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
  background: var(--surface);
}

.ro-driver-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
}

.ro-driver-row {
  text-align: left;
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--r-sm);
  padding: 10px 12px;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    box-shadow 0.15s;
  box-shadow: var(--shadow-sm);
}

.ro-driver-row:hover {
  background: var(--surface-2);
  box-shadow: var(--shadow-md);
}

.ro-driver-row.selected {
  border-color: var(--accent);
  background: var(--accent-bg);
  box-shadow:
    0 0 0 1px var(--accent),
    var(--shadow-sm);
}

.ro-driver-name {
  font-weight: 600;
  font-size: 13px;
}

.ro-driver-meta {
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 2px;
}

.ro-primary-btn {
  border: none;
  background: var(--accent);
  color: #fff;
  border-radius: var(--r-sm);
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(24, 95, 165, 0.25);
}

.ro-primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.ro-icon-btn {
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--r-sm);
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-sm);
}

.ro-banner {
  margin: 0 12px;
  padding: 10px 12px;
  border-radius: var(--r-sm);
  font-size: 12px;
  border: 1px solid transparent;
}

.ro-banner--ok {
  background: var(--ok-bg);
  color: var(--ok);
  border-color: #a7f3d0;
}

.ro-banner--warn {
  background: var(--warn-bg);
  color: var(--warn);
  border-color: #fde68a;
}

.ro-banner--bad {
  background: var(--bad-bg);
  color: var(--bad);
  border-color: #fecaca;
}

.ro-order-card {
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  padding: 12px;
  margin-bottom: 8px;
  background: var(--surface);
  box-shadow: var(--shadow-sm);
}

.ro-order-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.ro-order-meta {
  font-size: 12px;
  color: var(--ink-2);
  margin-top: 4px;
}

.ro-order-addr {
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 6px;
}

.ro-status {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  background: #e5e7eb;
  color: #374151;
}

.ro-status.status--assigned {
  background: #dbeafe;
  color: #1d4ed8;
}
.ro-status.status--picked {
  background: #fef3c7;
  color: #b45309;
}
.ro-status.status--onway {
  background: #d1fae5;
  color: #047857;
}

.ro-empty {
  text-align: center;
  color: var(--ink-3);
  padding: 24px 12px;
  font-size: 13px;
}

.ro-empty-lg {
  padding: 48px 24px;
}

.ro-empty-lg i {
  font-size: 32px;
  display: block;
  margin-bottom: 12px;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/Css/RouteOptimization.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;sEACoE;EACpE;uEACqE;EACrE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,WAAW;;EAEX,iBAAiB;EACjB;qEACmE;EACnE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf;;;oBAGkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B;;oBAEkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".ro-page {\r\n  --bg: #ffffff;\r\n  --surface: #ffffff;\r\n  --surface-2: #f8fafc;\r\n  --ink: #1e293b;\r\n  --ink-2: #475569;\r\n  --ink-3: #94a3b8;\r\n  --line: #e2e8f0;\r\n  --shadow-sm:\r\n    0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.08);\r\n  --shadow-md:\r\n    0 2px 4px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.08);\r\n  --ok-bg: #ecfdf5;\r\n  --ok: #047857;\r\n  --warn-bg: #fffbeb;\r\n  --warn: #b45309;\r\n  --bad-bg: #fef2f2;\r\n  --bad: #b91c1c;\r\n  --accent: #185fa5;\r\n  --accent-bg: #eff6ff;\r\n  --r: 10px;\r\n  --r-sm: 7px;\r\n\r\n  min-height: 100vh;\r\n  font-family:\r\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 13px;\r\n  color: var(--ink);\r\n  background: var(--bg);\r\n}\r\n\r\n.ro-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  padding: 18px 20px 0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ro-title {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ro-subtitle {\r\n  margin: 6px 0 0;\r\n  color: var(--ink-3);\r\n  font-size: 13px;\r\n  max-width: 520px;\r\n}\r\n\r\n.ro-kpis {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 12px;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.ro-kpi {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r);\r\n  padding: 14px 16px;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.ro-kpi-label {\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.ro-kpi-val {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin-top: 4px;\r\n}\r\n\r\n.ro-kpi-val-sm {\r\n  font-size: 18px;\r\n}\r\n\r\n.ro-kpi-foot {\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  margin-top: 2px;\r\n}\r\n\r\n.ro-layout {\r\n  display: grid;\r\n  grid-template-columns: 280px 1fr;\r\n  gap: 14px;\r\n  padding: 0 20px 24px;\r\n  min-height: 480px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .ro-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .ro-kpis {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.ro-panel {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r);\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  box-shadow: var(--shadow-md);\r\n  overflow: hidden;\r\n}\r\n\r\n.ro-panel-main {\r\n  min-height: 420px;\r\n}\r\n\r\n.ro-panel-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--line);\r\n  background: var(--surface-2);\r\n}\r\n\r\n.ro-panel-head-split {\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.ro-panel-title {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.ro-panel-sub {\r\n  display: block;\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  margin-top: 2px;\r\n}\r\n\r\n.ro-panel-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 12px;\r\n  background: var(--surface);\r\n}\r\n\r\n.ro-driver-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 8px;\r\n}\r\n\r\n.ro-driver-row {\r\n  text-align: left;\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  border-radius: var(--r-sm);\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 0.15s,\r\n    background 0.15s,\r\n    box-shadow 0.15s;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.ro-driver-row:hover {\r\n  background: var(--surface-2);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.ro-driver-row.selected {\r\n  border-color: var(--accent);\r\n  background: var(--accent-bg);\r\n  box-shadow:\r\n    0 0 0 1px var(--accent),\r\n    var(--shadow-sm);\r\n}\r\n\r\n.ro-driver-name {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n}\r\n\r\n.ro-driver-meta {\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  margin-top: 2px;\r\n}\r\n\r\n.ro-primary-btn {\r\n  border: none;\r\n  background: var(--accent);\r\n  color: #fff;\r\n  border-radius: var(--r-sm);\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 1px 2px rgba(24, 95, 165, 0.25);\r\n}\r\n\r\n.ro-primary-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.ro-icon-btn {\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  border-radius: var(--r-sm);\r\n  width: 32px;\r\n  height: 32px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.ro-banner {\r\n  margin: 0 12px;\r\n  padding: 10px 12px;\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.ro-banner--ok {\r\n  background: var(--ok-bg);\r\n  color: var(--ok);\r\n  border-color: #a7f3d0;\r\n}\r\n\r\n.ro-banner--warn {\r\n  background: var(--warn-bg);\r\n  color: var(--warn);\r\n  border-color: #fde68a;\r\n}\r\n\r\n.ro-banner--bad {\r\n  background: var(--bad-bg);\r\n  color: var(--bad);\r\n  border-color: #fecaca;\r\n}\r\n\r\n.ro-order-card {\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  padding: 12px;\r\n  margin-bottom: 8px;\r\n  background: var(--surface);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.ro-order-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ro-order-meta {\r\n  font-size: 12px;\r\n  color: var(--ink-2);\r\n  margin-top: 4px;\r\n}\r\n\r\n.ro-order-addr {\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  margin-top: 6px;\r\n}\r\n\r\n.ro-status {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 20px;\r\n  background: #e5e7eb;\r\n  color: #374151;\r\n}\r\n\r\n.ro-status.status--assigned {\r\n  background: #dbeafe;\r\n  color: #1d4ed8;\r\n}\r\n.ro-status.status--picked {\r\n  background: #fef3c7;\r\n  color: #b45309;\r\n}\r\n.ro-status.status--onway {\r\n  background: #d1fae5;\r\n  color: #047857;\r\n}\r\n\r\n.ro-empty {\r\n  text-align: center;\r\n  color: var(--ink-3);\r\n  padding: 24px 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.ro-empty-lg {\r\n  padding: 48px 24px;\r\n}\r\n\r\n.ro-empty-lg i {\r\n  font-size: 32px;\r\n  display: block;\r\n  margin-bottom: 12px;\r\n  opacity: 0.5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
